import banner1 from "../Asset/Balaji_Sansthan_Washim.JPG";
import banner2 from "../Asset/Ambejhar jain Temple.JPG";
import banner3 from "../Asset/Gajanan baba civil line.JPG";
import banner4 from "../Asset/Padmatirth.JPG";
import banner5 from "../Asset/Shani mandir.JPG";

// //import banner5 from "../Asset/Shankarbaba.JPG";
import { useEffect } from "react";

function BannerSlider() {

  useEffect(() => {
    // Ensure bootstrap carousel starts
    const carouselElement = document.querySelector("#bannerCarousel");
    if (carouselElement && window.bootstrap) {
      new window.bootstrap.Carousel(carouselElement, {
        interval: 100,
        ride: "carousel",
        pause: false,
        wrap: true
      });
    }
  }, []);

  return (
    <div
      id="bannerCarousel"
      className="carousel slide"
      data-bs-ride="carousel"
    >
      {/* Indicators */}
      <div className="carousel-indicators">
        <button data-bs-target="#bannerCarousel" data-bs-slide-to="0" className="active"></button>
        <button data-bs-target="#bannerCarousel" data-bs-slide-to="1"></button>
        <button data-bs-target="#bannerCarousel" data-bs-slide-to="2"></button>
        <button data-bs-target="#bannerCarousel" data-bs-slide-to="3"></button>
        <button data-bs-target="#bannerCarousel" data-bs-slide-to="4"></button>
      </div>

      {/* Slides */}
      <div className="carousel-inner">

        <div className="carousel-item active">
          <img
            src={banner1}
            className="d-block w-100"
            alt="Banner 1"
            style={{ height: "400px", objectFit: "cover" }}
          />
        </div>

        <div className="carousel-item">
          <img
            src={banner2}
            className="d-block w-100"
            alt="Banner 2"
            style={{ height: "400px", objectFit: "cover" }}
          />
        </div>

        <div className="carousel-item">
          <img
            src={banner3}
            className="d-block w-100"
            alt="Banner 3"
            style={{ height: "400px", objectFit: "cover" }}
          />
        </div>

        <div className="carousel-item">
          <img
            src={banner4}
            className="d-block w-100"
            alt="Banner 4"
            style={{ height: "400px", objectFit: "cover" }}
          />
        </div>

        <div className="carousel-item">
          <img
            src={banner5}
            className="d-block w-100"
            alt="Banner 5"
            style={{ height: "400px", objectFit: "cover" }}
          />
        </div>

      </div>
      <hr></hr>

      {/* Controls */}
      <button className="carousel-control-prev" type="button" data-bs-target="#bannerCarousel" data-bs-slide="prev">
        <span className="carousel-control-prev-icon"></span>
      </button>

      <button className="carousel-control-next" type="button" data-bs-target="#bannerCarousel" data-bs-slide="next">
        <span className="carousel-control-next-icon"></span>
      </button>
    </div>
  );
}

export default BannerSlider;